var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenNameChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.85786 3.85787 0.5 8 0.5L20 0.5C24.1421 0.5 27.5 3.85786 27.5 8V20C27.5 24.1421 24.1421 27.5 20 27.5H8C3.85786 27.5 0.5 24.1421 0.5 20L0.5 8Z",
    fill: "#070D27",
    stroke: "#857DFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0623 8.31358L19.5372 10.7885M14.875 21.8755H21.875M6.125 21.8759L6.16652 21.5852C6.31344 20.5568 6.3869 20.0425 6.554 19.5625C6.70228 19.1365 6.90484 18.7313 7.15668 18.3571C7.44049 17.9354 7.80779 17.5681 8.5424 16.8335L18.7344 6.64147C19.4178 5.95805 20.5259 5.95805 21.2093 6.64147C21.8927 7.32489 21.8927 8.43292 21.2093 9.11634L10.8303 19.4954C10.1638 20.1618 9.8306 20.495 9.45105 20.76C9.11415 20.9952 8.75081 21.1901 8.36848 21.3406C7.93774 21.5101 7.47579 21.6033 6.55194 21.7897L6.125 21.8759Z",
    stroke: "#857DFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNameChange);
export default __webpack_public_path__ + "static/media/openNameChange.2aaf9f7837ac335687860845dd9240b1.svg";
export { ForwardRef as ReactComponent };